module.exports = __webpack_public_path__ + "static/media/banner_pronostico_movil.ca0fa13f.png";